import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

/**
 * Small dialog that collects a required free-text reason and emits it.
 * Reused for rejecting an expense and for returning it to the submitter.
 */
@Component({
    selector: 'app-expense-reason-dialog',
    templateUrl: './expense-reason-dialog.component.html',
    standalone: false
})
export class ExpenseReasonDialogComponent {

  /** Translation keys for the dialog title and confirm button. */
  @Input() titleKey = 'reject';
  @Input() confirmKey = 'reject';

  @Output() confirm = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<void>();

  formGroup = new UntypedFormGroup({
    reason: new UntypedFormControl(null, Validators.required)
  });

  onConfirm() {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }
    this.confirm.emit(this.formGroup.value.reason);
  }

  onCancel() {
    this.cancel.emit();
  }
}
